@if (config(); as takeOffConfig) {
    @let measurement = takeoffMeasurement();
    @let disabled = isDisabled();
    @let hasDepth = isDepthEnabled();

    <section class="takeoff-toolbar">
        <div class="takeoff-toolbar-group border-radius-left" [ngClass]="{ disabled: disabled }" aria-label="takeoff-tools">
            <button
                *ngIf="takeOffConfig.canDrawShap || takeOffConfig.canDrawLine || takeOffConfig.canDrawPoint"
                type="button"
                id="insertPoint"
                class="takeoff-toolbar-group-button border-radius-left"
                [ngClass]="{ active: takeOffConfig.editable }"
                [disabled]="disabled"
                (click)="onAddPointModeChanged()"
                tooltip="Point edit"
                placement="bottom">
                @if (takeOffConfig.editable) {
                    <i class="fa-kit-duotone fa-bx-arrow-duotone"></i>
                } @else {
                    <i class="fa-light fa-arrow-pointer"></i>
                }
            </button>
            <button
                *ngIf="takeOffConfig.canDrawShap"
                type="button"
                id="toPolygon"
                class="takeoff-toolbar-group-button"
                [disabled]="!measurement || disabled"
                [popover]="hasDepth ? takeOffDepthTemplate : undefined"
                container="body"
                [ngClass]="{ active: takeOffConfig.shape === 'Polygon' }"
                tooltip="Polygon"
                placement="bottom"
                (click)="onChangeShape('Polygon')"
                #popoverPolygon="bs-popover">
                @if (takeOffConfig.shape === 'Polygon') {
                    <i class="fa-kit-duotone fa-bx-polygon-duotone"></i>
                } @else {
                    <i class="fa-light fa-hexagon"></i>
                }
            </button>
            <button
                *ngIf="takeOffConfig.canDrawShap"
                type="button"
                id="toRectangle"
                class="takeoff-toolbar-group-button"
                [disabled]="!measurement || disabled"
                [popover]="hasDepth ? takeOffDepthTemplate : undefined"
                container="body"
                [ngClass]="{ active: takeOffConfig.shape === 'Rectangle' }"
                tooltip="Rectangle"
                placement="bottom"
                (click)="onChangeShape('Rectangle')"
                #popoverRectangle="bs-popover">
                @if (takeOffConfig.shape === 'Rectangle') {
                    <i class="fa-kit-duotone fa-bx-square-duotone"></i>
                } @else {
                    <i class="fa-light fa-square"></i>
                }
            </button>
            <button
                *ngIf="takeOffConfig.canDrawShap"
                type="button"
                id="toEllipse"
                class="takeoff-toolbar-group-button"
                [disabled]="!measurement || disabled"
                [popover]="hasDepth ? takeOffDepthTemplate : undefined"
                container="body"
                [ngClass]="{ active: takeOffConfig.shape === 'Ellipse' }"
                tooltip="Ellipse"
                placement="bottom"
                (click)="onChangeShape('Ellipse')"
                #popoverEllipse="bs-popover">
                @if (takeOffConfig.shape === 'Ellipse') {
                    <i class="fa-kit-duotone fa-bx-circle-duotone"></i>
                } @else {
                    <i class="fa-light fa-circle"></i>
                }
            </button>
            <button
                *ngIf="takeOffConfig.canDrawLine"
                type="button"
                id="toLine"
                class="takeoff-toolbar-group-button"
                [disabled]="!measurement || disabled"
                [popover]="hasDepth ? takeOffDepthTemplate : undefined"
                container="body"
                [ngClass]="{ active: takeOffConfig.shape === 'Line' }"
                tooltip="Line"
                placement="bottom"
                (click)="onChangeShape('Line')"
                #popoverLine="bs-popover">
                <i class="fa-kit fa-bx-line-diagonal"></i>
            </button>
            <button
                *ngIf="takeOffConfig.canDrawPoint"
                type="button"
                id="toPoint"
                class="takeoff-toolbar-group-button"
                [disabled]="!measurement || disabled"
                [ngClass]="{ active: takeOffConfig.shape === 'Point' }"
                tooltip="Point"
                placement="bottom"
                (click)="onChangeShape('Point')">
                @if (takeOffConfig.shape === 'Point') {
                    <i class="fa-kit-duotone fa-bx-count-duotone"></i>
                } @else {
                    <i class="fa-thin fa-circle-dot"></i>
                }
            </button>
        </div>

        <div class="takeoff-toolbar-group" [ngClass]="{ disabled: disabled || !measurement }" aria-label="takeoff-tools">
            <button
                type="button"
                id="toDeduction"
                class="takeoff-toolbar-group-button"
                tooltip="Draws a deduction"
                placement="bottom"
                [ngClass]="{ active: takeOffConfig.negative }"
                (click)="onDeduct()"
                [disabled]="!measurement || disabled || takeOffConfig.editable">
                <i class="fa-kit fa-bx-subtract"></i>
            </button>

            <app-take-off-drawing-color-picker
                [selectedColor]="takeOffConfig.color"
                (colorChanges)="onColorChanged($event)"
                [disabled]="!measurement || disabled || takeOffConfig.editable">
            </app-take-off-drawing-color-picker>
        </div>

        <app-take-off-pitch-dropdown
            *ngIf="takeOffConfig.canDrawLine"
            [degrees]="takeOffConfig.pitch"
            [ratio]="takeOffConfig.pitchRatio"
            [isHeader]="true"
            (pitchChanged)="pitchChanged($event)"
            [disabled]="!measurement || disabled || takeOffConfig.editable">
        </app-take-off-pitch-dropdown>
    </section>

    <ng-template #takeOffDepthTemplate>
        <app-take-off-drawing-depth
            [shape]="takeOffConfig.shape"
            [unit]="takeOffConfig.uom.toLowerCase()"
            [depth]="takeOffConfig.depth"
            [depthUnit]="takeOffConfig.depthUnit"
            (depthChanges)="onDepthChanged($event)"
            (depthUnitChanges)="onDepthUnitChanged($event)">
        </app-take-off-drawing-depth>
    </ng-template>
}
